import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Bowser from 'bowser'
import './registerServiceWorker'

import store from './store'
import '@/assets/css/tailwind.scss'
import 'codemirror/lib/codemirror.css'

const browser = Bowser.getParser(window.navigator.userAgent)

window.isSupportedBrowser = browser.satisfies({
  desktop: {
    edge: '>=16',
    safari: '>=11',
    chrome: '>=57',
    firefox: '>=53',
    opera: '>=64',
  },  
  mobile: {
    safari: '>=11',
    chromium: '>=57',
    chrome: '>=57',
    firefox: '>=68',
    'android browser': '>=76'
  }
})

Vue.config.productionTip = false

window.vue = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

if (window.isSupportedBrowser) {
  require('./php.js')
}

window.addEventListener('message', function (e) {
    if (e.data.event === 'iframe-link-click') {
      window.vue.$emit('iframe-link-click', e.data.data);
    }
    if (e.data.event === 'iframe-form-submit') {
      window.vue.$emit('iframe-form-submit', e.data.data);
    }
    if (e.data.event === 'iframe-fetch') {
      window.vue.$emit('iframe-fetch', e.data.data);
    }
});